import { Controller } from 'react-hook-form';
import { useState } from 'react';
import copy from 'copy-to-clipboard';
import SidepanelDefaultRow from '../side-panel/side-panel-default-row';
import Select from '../select/select';
import { RowProps } from './types';
import IconCopy from '../icons/copy-two';

import styles from './transaction.module.css';

export default function SidepanelSelectRow({
  title,
  name,
  value,
  control,
  enableEdit,
  placeholder,
  selectListPosition,
  selectList,
  borderless = false,
  error,
  disabled,
  tabIndex,
  copyEnabled,
  copyValue,
  withClearButton,
}: RowProps): React.JSX.Element {
  const [copyIsSuccess, setCopyIsSuccess] = useState(false);

  const onCopy = () => {
    setCopyIsSuccess(true);
    copy(copyValue as string);

    setTimeout(() => {
      setCopyIsSuccess(false);
    }, 2000);
  };

  let content;

  if (enableEdit) {
    content = (
      <Controller
        name={name}
        control={control}
        rules={{ required: false }}
        defaultValue={value}
        render={({ field }) => (
          <Select
            title={title}
            list={selectList || []}
            placeholder={placeholder}
            name={name}
            value={field.value}
            onChange={(e) => field.onChange(e)}
            selectListPosition={selectListPosition}
            borderless={borderless}
            fullWidth
            error={error}
            disabled={disabled}
            tabIndex={tabIndex}
            withClearButton={withClearButton}
          />
        )}
      />
    );
  } else {
    content = value;
  }

  return (
    <SidepanelDefaultRow
      title={enableEdit ? undefined : title}
      valueClassName={`${copyEnabled && enableEdit ? styles.rowWithCopy : ''} ${
        copyEnabled && !enableEdit ? styles.readCopyButtonWrapper : ''
      }`}
    >
      {content}
      {copyEnabled && (
        <>
          {enableEdit && (
            <button
              type="button"
              className={`${styles.copyButton} ${
                styles.autocompleteCopyButton
              } ${copyIsSuccess ? styles.success : ''}`}
              onClick={onCopy}
              aria-label="Copy"
            >
              <IconCopy />
            </button>
          )}
          {!enableEdit && (
            <button
              type="button"
              className={`${styles.readCopyButton} ${
                copyIsSuccess ? styles.success : ''
              }`}
              onClick={onCopy}
              aria-label="Copy"
            >
              <IconCopy />
            </button>
          )}
        </>
      )}
    </SidepanelDefaultRow>
  );
}
